const state = {
  dataAoFConf: [],
  layoutAoFConf: {},
  areasAoFConf: [],
  selectedIdValueAoFConf: '',
  selectedX1ValueAoFConf: 0,
  selectedX2ValueAoFConf: 0,
  selectedIndxAoFConf: -1,
  selectionFlagAoFConf: false,
  minValueXAoFConf: 0,
  maxValueXAoFConf: 0,
};

const getters = {
  getDataAoFConf: (state) => state.dataAoFConf,
  getLayoutAoFConf: (state) => state.layoutAoFConf,
  getAreasAoFConf: (state) => state.areasAoFConf,
  getSelectedIdAxisAoFConf: (state) => state.selectedIdValueAoFConf,
  getSelectedX1AxisAoFConf: (state) => state.selectedX1ValueAoFConf,
  getSelectedX2AxisAoFConf: (state) => state.selectedX2ValueAoFConf,
  getSelectedIndxAoFConf: (state) => state.selectedIndxAoFConf,
  isSelectedAoFConf: (state) => state.selectionFlagAoFConf,
  getMinValueXAoFConf: (state) => state.minValueXAoFConf,
  getMaxValueXAoFConf: (state) => state.maxValueXAoFConf,
};

const actions = {
  setPlotAoFConf({ commit }, { data, layout, areas }) {
    const MinValueXAoFConf = Math.min(
      ...data.map((dataAoF) => {
        return Math.min(...dataAoF.x);
      }),
    );
    const MaxValueXAoFConf = Math.max(
      ...data.map((dataAoF) => {
        return Math.max(...dataAoF.x);
      }),
    );
    commit('SET_LAYOUT_AoFConf', layout);
    commit('SET_DATA_AoFConf', data);
    commit('SET_AREAS_AoFConf', areas);
    commit('SET_MIN_VALUE_X_AoFCinf', MinValueXAoFConf);
    commit('SET_MAX_VALUE_X_AoFCinf', MaxValueXAoFConf);
  },
  setSelectedX1AxisAoFConf({ commit, state }, newXValue) {
    newXValue = Math.round(newXValue * 100) / 100; // Round two decimals
    if (state.selectionFlagAoFConf) {
      let areas = state.areasAoFConf;
      areas[state.selectedIndxAoFConf][1] = newXValue;
      commit('SET_AREAS_AoFConf', areas);
    }
    commit('SET_SELECTED_X1_AXIS_AoFConf', newXValue);
  },
  setSelectedIdAxisAoFConf({ commit, state }, newIdValue) {
    if (state.selectionFlagAoFConf) {
      let areas = state.areasAoFConf;
      areas[state.selectedIndxAoFConf][0] = newIdValue;
      commit('SET_AREAS_AoFConf', areas);
    }
    commit('SET_SELECTED_ID_AXIS_AoFConf', newIdValue);
  },
  setSelectedX2AxisAoFConf({ commit, state }, newXValue) {
    newXValue = Math.round(newXValue * 100) / 100; // Round two decimals
    if (state.selectionFlagAoFConf) {
      let areas = state.areasAoFConf;
      areas[state.selectedIndxAoFConf][2] = newXValue;
      commit('SET_AREAS_AoFConf', areas);
    }
    commit('SET_SELECTED_X2_AXIS_AoFConf', newXValue);
  },
  setSelectedIndxAoFConf({ commit, state }, newIndx) {
    commit('SET_SELECTED_INDX_AoFConf', newIndx);
    if (newIndx < 0) {
      return;
    }
    commit('SET_SELECTED_ID_AXIS_AoFConf', state.areasAoFConf[newIndx][0]);
    commit('SET_SELECTED_X1_AXIS_AoFConf', state.areasAoFConf[newIndx][1]);
    commit('SET_SELECTED_X2_AXIS_AoFConf', state.areasAoFConf[newIndx][2]);
  },
  setSelectionFlagAoFConf({ commit }, newBool) {
    commit('SET_SELECTION_FLAG_AoFConf', newBool);
  },
  updateXAxisAoFConf({ commit }, { index, newXVal }) {
    let areas = state.areasAoFConf;
    areas[index] = newXVal;
    if (state.selectionFlagAoFConf && state.selectedIndxAoFConf === index) {
      commit('SET_SELECTED_ID_AXIS_AoFConf', newXVal[0]);
      commit('SET_SELECTED_X1_AXIS_AoFConf', newXVal[1]);
      commit('SET_SELECTED_X2_AXIS_AoFConf', newXVal[2]);
    }
    commit('SET_AREAS_AoFConf', areas);
  },
  updateTableAreaAoFConf({ commit, state }, { row, arrIndex, newXVal }) {
    let areas = state.areasAoFConf;
    areas[row][arrIndex] = newXVal;
    if (state.selectionFlagAoFConf && state.selectedIndxAoFConf === row) {
      if (arrIndex === 0) {
        commit('SET_SELECTED_ID_AXIS_AoFConf', newXVal);
      } else if (arrIndex === 1) {
        commit('SET_SELECTED_X1_AXIS_AoFConf', newXVal);
      } else if (arrIndex === 2) {
        commit('SET_SELECTED_X2_AXIS_AoFConf', newXVal);
      }
    }
    commit('SET_AREAS_AoFConf', areas);
  },
  addAreaAoFConf({ commit, state }, { X1Value, rangeXAxis }) {
    // Default value
    let X2Value = X1Value + rangeXAxis * 0.05;
    const areas = state.areasAoFConf;
    if (areas.length === 1) {
      X2Value = X1Value + Math.abs(areas[0][1] - areas[0][2]); //If there is one element, it would copy the same width
    } else if (areas.length > 1) {
      //If there is more than one, it would calculate the average
      X2Value = 0;
      for (let j = 0; j < areas.length; j++) {
        X2Value += Math.abs(areas[j][1] - areas[j][2]);
      }
      X2Value /= areas.length;
      X2Value += X1Value;
    }

    areas.push(['', X1Value, X2Value]);
    //areas.sort(function(a, b){return a[1] - b[1]})
    commit('SET_AREAS_AoFConf', areas);
    return X2Value;
  },
  deleteAreaAoFConf({ commit }, index) {
    let areas = state.areasAoFConf;
    areas.splice(index, 1);
    commit('SET_AREAS_AoFConf', areas);
  },
  resetAreasAoFConf({ commit }) {
    commit('SET_AREAS_AoFConf', []);
  },
  setShapesGraphAoFConf({ commit }, newShapes) {
    commit('SET_SHAPES_GRAPH_AoFConf', newShapes);
  },
  setAreaAoFConf({ commit }, newConc) {
    commit('SET_AREAS_AoFConf', newConc);
  },
};

const mutations = {
  SET_DATA_AoFConf: (state, dataAoFConf) => (state.dataAoFConf = dataAoFConf),
  SET_LAYOUT_AoFConf: (state, layoutAoFConf) =>
    (state.layoutAoFConf = layoutAoFConf),
  SET_SELECTED_X1_AXIS_AoFConf: (state, XValue) =>
    (state.selectedX1ValueAoFConf = XValue),
  SET_SELECTED_ID_AXIS_AoFConf: (state, XValue) =>
    (state.selectedIdValueAoFConf = XValue),
  SET_SELECTED_X2_AXIS_AoFConf: (state, XValue) =>
    (state.selectedX2ValueAoFConf = XValue),
  SET_SELECTED_INDX_AoFConf: (state, indx) =>
    (state.selectedIndxAoFConf = indx),
  SET_SELECTION_FLAG_AoFConf: (state, boolVal) =>
    (state.selectionFlagAoFConf = boolVal),
  SET_AREAS_AoFConf: (state, newConcs) => (state.areasAoFConf = newConcs), //It is possible to trigger the watch event, by changing this commits to $set
  SET_SHAPES_GRAPH_AoFConf: (state, newShapes) =>
    (state.layoutAoFConf.shapes = newShapes),
  SET_MIN_VALUE_X_AoFCinf: (state, newFloat) =>
    (state.minValueXAoFConf = newFloat),
  SET_MAX_VALUE_X_AoFCinf: (state, newFloat) =>
    (state.maxValueXAoFConf = newFloat),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
